export interface FAQItemData {
    category: string;
    question: string;
    answer: string;
}

export const faqColumns: FAQItemData[][] = [
    // Column 1
    [
        {
            category: "Proces & vervolg",
            question: "Wat gebeurt er met mijn brief?",
            answer: "Je brief wordt altijd gelezen en er wordt aan je gedacht. Als je een retouradres achterlaat, kan je een reactie terug verwachten. Dat kan wat geduld vragen. We legen de bus wekelijks. We gaan zorgvuldig met de brieven om en zoeken naar een passende bemoediging."
        },
        {
            category: "Algemeen",
            question: "waar zijn de ansichtkaarten te vinden?",
            answer: "Onze ansichtkaarten vind je naast de brievenbussen, maar je mag ook op een kladblaadje of ander briefpapier aan ons schrijven. Denk aan het vermelden van je adres als je een reactie wilt. "
        },
        {
            category: "Algemeen",
            question: "Mag iedereen een brief sturen?",
            answer: "Ja, dat mag, we zijn er voor iedereen. Ook als je niet in de gemeente Harderwijk woont mag je gerust een brief posten. In verband met kosten versturen we geen reacties naar het buitenland."
        }
    ],
    // Column 2
    [
        {
            category: "Privacy",
            question: "Wie leest mijn brief?",
            answer: "Je brief wordt gelezen door Henk Ruiter, Mattanja Hoenderdos of Anne Marie Goudkuil. Zij kunnen zelf reageren of een lokale dichter of kunstenaar benaderen voor een bemoediging die past bij de brief. De mensen die betrokken zijn bij Opluchtpost zijn mensen die omkijken naar anderen, empathisch en invoelend zijn. Je verhaal is in zorgvuldige handen. Misschien wordt je brief doorgestuurd naar een lokale kunstenaar of schrijver om een mooie reactie te produceren. Dit gebeurt anoniem, dus zonder vermelding van je persoonsgegevens."
        },
        {
            category: "Algemeen",
            question: "Waarom kan ik niet online wat insturen?",
            answer: "Wij geloven in de kracht van offline. Daar gebeurt het echte leven. Online is snel en gemakkelijk, maar als het over dieperliggende thema’s gaat zijn dat niet altijd de kwaliteiten die helpend zijn. Je gedachten op papier zetten is trager, maar kan ook helpen ze te ordenen. Een brief retour ontvangen is tastbaar, iemand heeft de tijd voor jouw verhaal genomen. Het is persoonlijker dan een appje met een welgemeende tekst of gifje. Je kan zelf een moment kiezen om het te lezen. En: er wordt niets van je terug verwacht. "
        },
        {
            category: "Algemeen",
            question: "Zijn er kosten aan verbonden?",
            answer: "Nee, het is helemaal gratis en vrijblijvend. Wil je ons steunen? Je kan een postzegel voor de retourzending meegeven met je brief."
        }
    ],
    // Column 3
    [
        {
            category: "Partners",
            question: "Met wie werken we samen?",
            answer: "Onze brievenbussen zijn te vinden in de Bibliotheek Harderwijk, het Stadsmuseum Harderwijk en ziekenhuis St Jansdal Harderwijk. We hebben een netwerk van lokale dichters en kunstenaars die betrokken zijn bij Opluchtpost. Opluchtpost is mede mogelijk gemaakt met dank aan de ondersteuning van de gemeente Harderwijk."
        },
        {
            category: "Privacy",
            question: "Bewaren jullie mijn brief?",
            answer: "We archiveren de brieven die binnenkomen bij opluchtpost zorgvuldig en zonder adresgegevens. Heb je liever niet dat we je brief bewaren? Dit kan je in je brief vermelden. Ook kan je altijd nog een bericht sturen dat je je brief wil laten vernietigen."
        }
    ]
];
